import React from 'react';

export interface TooltipCustomItemProps {
  label?: string;
  icon?: React.ReactNode;
  value: string;
}

const TooltipCustomItem = ({ label, icon, value }: TooltipCustomItemProps) => (
  <div className="tooling-tooltip__custom-item">
    {label && <span className="tooling-tooltip__row-label">{label}</span>}
    {value && <span className="tooling-tooltip__row-value">{value}</span>}
    {icon}
  </div>
);

TooltipCustomItem.displayName = 'ToolingCoverageTooltip.CustomItem';

export default TooltipCustomItem;
